/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import Box from '../Grid/Box';
import SemiTitle from '../Text/SemiTitle';

export default function Section({ children, title, ...rest }) {
  return (
    <Box as="section" sx={{ marginY: 4 }} {...rest}>
      {title && <SemiTitle>{title}</SemiTitle>}
      {children}
    </Box>
  );
}

Section.Title = SemiTitle;
